import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { LoadConfigService } from '../../services/load-config.service';
import { InstructionModificationService } from '../../services/instruction-modification.service';
import { InstructionService } from '../../services/instruction.service';

@Component({
  selector: 'app-instruction-container',
  templateUrl: './instruction-container.component.html',
  styleUrls: ['./instruction-container.component.scss'],
})
export class InstructionContainerComponent implements OnInit, OnDestroy {
  @Input('showCountdown') showCountdown: boolean = false;
  countdownStart: number = 3;

  @Input('instruction') instruction: string = null;
  @Input('section') section: string = null;
  @Input('time') time: number = 3;

  timer;

  content: string;

  constructor(
    private navigationService: StudyNavigationService,
    private loadConfigService: LoadConfigService,
    private modifyInstruction: InstructionModificationService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    if (!this.showCountdown) {
      // const keys = this.getKeys();

      this.setInstruction();

      // TODO: need to make sure that this does not mess up instructions that are not timed
      this.timer = setTimeout(() => {
        this.navigationService.renderNext();
      }, this.time * 1000);
    }

    this.countdownStart = this.loadConfigService.getCountdownLength();
  }

  ngOnDestroy(): void {
    clearTimeout(this.timer);
  }

  setInstruction() {
    this.content = this.modifyInstruction.replacePlaceholders(
      this.instructionService.getInstructions('EN')[this.instruction]?.body,
      this.instruction,
      this.section
    );
  }
}
